import { Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';


@Component({
    selector: 'app-menu',
    imports: [RouterLink, RouterLinkActive],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss'
})

export class MenuComponent {

  showHostedPortal = input(false); 
  showMySoftProUsers = input(false);
  showOnlineBillPay = input(false);

}
